import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-534b8d64"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-wrapper" }
const _hoisted_2 = { class: "right-wrapper el-card" }
const _hoisted_3 = { class: "header-wrapper" }
const _hoisted_4 = { class: "action-row cm-ui-mb15" }
const _hoisted_5 = { class: "cm-ui-ml30 repair-intro-row" }
const _hoisted_6 = { class: "select-txt-box" }
const _hoisted_7 = { class: "cm-ui-ml30 select-fix-box" }
const _hoisted_8 = {
  key: 0,
  class: "select-item-icon"
}
const _hoisted_9 = { class: "port-list-tip-count" }

import { computed, reactive, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { ElMessage } from 'element-plus'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import ContentAdaptLayout from '@/views/dashboard/_components/content-adapt-layout/content-adapt-layout.vue'
import CmTable from '@/components/cmTable/index.vue'
import type { TableOpt } from '@/components/cmTable/types'
import { useCmTableListRefresh } from '@/hooks/use-cm-table-list-refresh'
import BaseTree from '@/views/dashboard/_components/group-tree/base-tree.vue'
import CmTableSelectionTipBar from '@/views/dashboard/_components/cmtable-selection-tip-bar/cmtable-selection-tip-bar.vue'
import type { Group } from '@/views/dashboard/_type/group'
import WindowsRepairWrapper
  from '@/views/dashboard/safe-status/base-line/_components/repair-item-drawer/repair-system-wrapper/windows-repair-wrapper.vue'
import LinuxRepairWrapper
  from '@/views/dashboard/safe-status/base-line/_components/repair-item-drawer/repair-system-wrapper/linux-repair-wrapper.vue'
import { SystemType } from '@/views/dashboard/safe-status/base-line/repair-item-tree-type'
import UnauthorizedTooltip from '@/views/dashboard/_components/unauthorized-tooltip/unauthorized-tooltip.vue'
import { TableDataRowState, TableState } from '@/services/table-memory-pagination'
import {
  BaseLineRepairDrawerService,
  CheckResult,
  IdsCount,
  QueryParams,
  RepairParams,
  RepairTerminalItem
} from '@/views/dashboard/safe-status/base-line/_components/baseLine-repair-drawer/baseLine-repair-drawer.service'
import { getAuthByList, PermissionFe } from '@/services/service-permission.service'
import { AreaType } from '@/views/dashboard/service/_enum/area-type'
import { TerminalAuthStatus } from '@/views/dashboard/_enum/terminal-auth-status'
import { formatTimeStamp } from '@/utils/time'


export default /*#__PURE__*/_defineComponent({
  __name: 'baseLine-repair-drawer',
  emits: ["closeRepairDrawer", "syncRepairTaskId", "authSuccess"],
  setup(__props, { emit: __emit }) {

const emit = __emit

const { t, locale } = useI18n()
const injector = useReflectiveInjector([BaseLineRepairDrawerService])
const service = injector.get(BaseLineRepairDrawerService)

const ModulePermissionKey = {
  [AreaType.linux]: PermissionFe.linux_base_auth,
}

function isDisabled(row: RepairTerminalItem) {
  return getAuthByList(row.auth_status, ModulePermissionKey[row.area_type]) !== TerminalAuthStatus.normal
}

service.isDisabled = isDisabled

const tableRef = ref<{ getList: () => Promise<unknown> } | null>(null)
const { refreshList } = useCmTableListRefresh(tableRef)

const listForm = reactive<QueryParams>({
  group_id: -1,
  page: 1,
  limit: 20,
  sort: '',
  asc: false,
  useMemory: false,
  check_result: CheckResult.unPass,
  permission_names: [ModulePermissionKey[AreaType.linux]],
})

const viewData = ref({
  tableData: [] as TableDataRowState<RepairTerminalItem>[],
  state: {} as TableState<TableDataRowState<RepairTerminalItem>>,
  total: 0,
})

/** CmTable dataFormate 产出的渲染数据引用，直接修改其元素 $selected 可触发 Vue 响应式更新 */
const renderedData = ref<TableDataRowState<RepairTerminalItem>[]>([])

/** 本次 listApi 是否为滚动加载追加（listApi 先于 dataFormate 执行，这里传递模式） */
let isAppendMode = false

const repairData = reactive({
  total: 0,
  alen: 0,
  nlen: 0,
  ilen: 0,
  autoIDs: [] as string[],
  notifyIDs: [] as string[],
  hasWindows: true,
  hasLinux: true,
  subIds: [] as string[]
})

const activeName = ref('baseline-win-terminals')
const repairItemDrawer = ref(false)

function pullServiceState() {
  const state = service.getViewState()
  viewData.value.state = state
  viewData.value.tableData = state.data.list
  viewData.value.total = state.data.total
}

function listDataFormate(rows: TableDataRowState<RepairTerminalItem>[] = []) {
  const { selectAll } = service.getViewState()
  const selectedData = service.getSelectedData()
  // 参照 ScanReport.vue：返回新对象 + 新数组，让 Vue 能检测到引用变化触发重渲染
  const formatted = rows.map(row => ({
    ...row,
    $selected: selectAll ? !isDisabled(row) : !!selectedData.find(r => service.isEqual(r, row))
  }))
  // 滚动加载时 listApi 只返回新增 chunk，渲染数据需拼接而不是替换（与 CmTable 内部 concat 一致）
  renderedData.value = isAppendMode ? [...renderedData.value, ...formatted] : formatted
  return formatted
}

function setCountData(sids: string[]) {
  const lens: IdsCount = service.generateIDs(sids)
  repairData.alen = lens.alen
  repairData.nlen = lens.nlen
  repairData.ilen = lens.ilen
  repairData.total = lens.total
  repairData.autoIDs = lens.autoIDs
  repairData.notifyIDs = lens.notifyIDs
}

function resetRepairDataCount() {
  repairData.total = 0
  repairData.alen = 0
  repairData.nlen = 0
  repairData.ilen = 0
}

async function getRepairDataCount() {
  const devices = service.getSelectedData()
  if (!devices.length) {
    resetRepairDataCount()
    repairData.subIds = []
    repairData.hasWindows = true
    repairData.hasLinux = true
    activeName.value = 'baseline-win-terminals'
    return
  }
  try {
    const res = await service.getSubStandardIds({
      select_type: 1,
      group_id: listForm.group_id,
      device_list: devices.map(item => item.device_id)
    })
    repairData.subIds = res.substandard_ids
    setCountData(res.substandard_ids)
    repairData.hasWindows = devices.some(device => [SystemType.Windows, SystemType.WinServer].includes(device.system_type))
    repairData.hasLinux = devices.some(device => device.system_type === SystemType.Linux)
    activeName.value = repairData.hasWindows ? 'baseline-win-terminals' : 'baseline-linux-terminals'
  } catch {
    resetRepairDataCount()
    repairData.subIds = []
  }
}

async function listApi(params: Record<string, unknown>) {
  listForm.page = Number(params.page) || 1
  listForm.limit = Number(params.limit) || 20
  if (params.sort !== undefined) {
    listForm.sort = params.sort as string
  }
  if (params.asc !== undefined) {
    listForm.asc = params.asc as boolean
  }
  // 滚动加载：page > 1 视为追加，服务状态累积全部已加载页（参照 file-dispatch dispatch-terminal）
  isAppendMode = listForm.page > 1
  const prevLen = isAppendMode ? service.getViewState().data.list.length : 0
  await service.refresh(listForm, isAppendMode)
  pullServiceState()
  const listChunk = isAppendMode ? viewData.value.tableData.slice(prevLen) : viewData.value.tableData
  return {
    list: listChunk,
    total: viewData.value.total
  }
}

const tableOpt = computed<TableOpt>(() => {
  void locale.value
  return {
    showTip: false,
    selection: false,
    rowKey: 'device_id',
    path: 'list',
    totalPath: 'total',
    height: '100%',
    showActionBar: false,
    showSearch: false,
    showRightToolbar: false,
    bodyStyle: 'height: 100%; padding: 0',
    containerOpt: { style: { flex: '1', minHeight: 0, overflow: 'hidden' } },
    columns: [
      {
        prop: '__sel',
        label: '',
        width: 52,
        columnOpt: { fixed: 'left', align: 'center' }
      },
      {
        prop: 'computer_name',
        label: t('listColumns.computerName'),
        type: 'COMPUTER',
        columnOpt: { minWidth: 180 }
      },
      {
        prop: 'user_mark',
        label: t('listColumns.userMark'),
        columnOpt: { width: 130 },
        formatter: (_row: RepairTerminalItem, value: string) => value || '--'
      },
      {
        prop: 'system_ip',
        label: t('listColumns.ipAddress'),
        type: 'IP',
        columnOpt: { minWidth: 150 }
      },
      {
        prop: 'system_name',
        label: t('safeProtectionModule.os'),
        columnOpt: { minWidth: 140 }
      },
      {
        prop: 'last_check_time',
        label: t('safeProtectionModule.lastScanCol'),
        columnOpt: { width: 160 },
        formatter: (_row: RepairTerminalItem, value: number) => {
          return value ? formatTimeStamp(value, 'YYYY-MM-DD HH:mm') : t('safeProtectionModule.notScanned')
        }
      },
    ]
  }
})

function tipBarSelectedCount() {
  if (viewData.value.state.selectAll) return viewData.value.state.selectCount
  return renderedData.value.filter((r) => r.$selected).length
}

function rowSelectable(row: TableDataRowState<RepairTerminalItem>) {
  return !isDisabled(row)
}

const hasSelectableRows = computed(() => renderedData.value.some(rowSelectable))

function pageSelectAllChecked(rows: TableDataRowState<RepairTerminalItem>[]) {
  const enabled = rows.filter((r) => rowSelectable(r))
  return enabled.length > 0 && enabled.every((r) => r.$selected)
}

function pageSelectAllIndeterminate(rows: TableDataRowState<RepairTerminalItem>[]) {
  const enabled = rows.filter((r) => rowSelectable(r))
  return enabled.some((r) => r.$selected) && !enabled.every((r) => r.$selected)
}

function pageHeaderAllDisabled(rows: TableDataRowState<RepairTerminalItem>[]) {
  if (!rows.length) return true
  return !rows.some((r) => rowSelectable(r))
}

async function handlePageSelectAllHeader(rows: TableDataRowState<RepairTerminalItem>[], checked: boolean) {
  const enabled = rows.filter((r) => rowSelectable(r))
  if (checked) {
    // 直接修改渲染数据上的 $selected
    enabled.forEach(r => { r.$selected = true })
    service.mergeSelectedData(enabled)
  } else {
    rows.forEach(r => { r.$selected = false })
    service.mergeSelectedData([])
  }
  pullServiceState()
  if (checked) {
    await getRepairDataCount()
  } else {
    resetRepairDataCount()
  }
}

async function handleCheckbox(row: TableDataRowState<RepairTerminalItem>) {
  if (viewData.value.state.selectAll) return
  // 直接修改渲染数据上的 $selected，走 Vue Proxy 触发响应式
  row.$selected = !row.$selected
  service.mergeSelectedData(service.getSelectedData(), row)
  pullServiceState()
  await getRepairDataCount()
}

async function getData(isKeepPage = false) {
  if (!isKeepPage) {
    listForm.page = 1
  }
  await refreshList()
}

async function handleRepairNotify() {
  const params: RepairParams = {
    select_type: 1,
    device_list: [],
    group_id: listForm.group_id,
    repair_item_ids: repairData.autoIDs,
    notice_item_ids: repairData.notifyIDs
  }
  if (viewData.value.state.selectAll) {
    params.select_type = 2
  } else {
    params.device_list = service.getSelectedData().map(item => item.device_id)
  }
  if (!repairData.alen && !repairData.nlen) {
    ElMessage.warning(t('safeProtectionModule.noRepairSelected'))
    return
  }
  try {
    const res = await service.getRepairNotification(params)
    emit('closeRepairDrawer')
    if (repairData.alen) {
      emit('syncRepairTaskId', res.task_id)
    }
    ElMessage.success(t('safeProtectionModule.repairNotifySent'))
  } catch {
    ElMessage.error(t('common.failed'))
  }
}

function openRepairItemDrawer() {
  repairItemDrawer.value = true
}

function handleRepairDrawerClose() {
  setCountData(repairData.subIds)
  repairItemDrawer.value = false
}

async function repairGroupSelected(row: Group) {
  listForm.useMemory = false
  listForm.group_id = row.group_id
  service.cancelSelectAll()
  pullServiceState()
  resetRepairDataCount()
  await getData()
}

async function handleTipSelect(type: 'all' | 'reverse') {
  const enabled = renderedData.value.filter((r) => rowSelectable(r))
  if (type === 'all') {
    // 直接修改渲染数据上的 $selected
    enabled.forEach(r => { r.$selected = true })
    service.mergeSelectedData(enabled)
    pullServiceState()
    await getRepairDataCount()
    return
  }
  // reverse: 逐个翻转
  for (const row of enabled) {
    row.$selected = !row.$selected
    service.mergeSelectedData(service.getSelectedData(), row)
  }
  pullServiceState()
  await getRepairDataCount()
}

async function selectAll() {
  listForm.page = 1
  listForm.useMemory = false
  service.selectAll()
  pullServiceState()
  // 先刷新列表数据，让 CmTable 内部 data.value 替换为新对象并触发重渲染，checkbox 才能同步勾选
  await getData()
  try {
    const res = await service.getSubStandardIds({ select_type: 2, group_id: listForm.group_id, device_list: [] })
    repairData.subIds = res.substandard_ids
    setCountData(res.substandard_ids)
  } catch {
    ElMessage.error(t('common.failed'))
  }
}

async function selectCancel() {
  listForm.useMemory = false
  service.cancelSelectAll()
  pullServiceState()
  resetRepairDataCount()
  await getData()
}

function calcSelectAllScopeDisabled() {
  if (!viewData.value.total || viewData.value.state.selectAll) return true
  return !hasSelectableRows.value
}

async function handleAuthSuccess() {
  await getData()
  emit('authSuccess')
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_i18n_t = _resolveComponent("i18n-t")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createBlock(ContentAdaptLayout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(BaseTree, {
          "data-api": "/baselinecheck/group-substandard/stat",
          onTerminalGroupSelected: repairGroupSelected
        }),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(CmTable, {
            ref_key: "tableRef",
            ref: tableRef,
            modelValue: listForm,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((listForm) = $event)),
            class: "repair-drawer-cmtable",
            "table-opt": tableOpt.value,
            api: listApi,
            "data-formate": listDataFormate,
            "page-option": { pageNumName: 'page', pageSizeName: 'limit' },
            "first-loading": true
          }, {
            header: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    disabled: !viewData.value.state.selectCount,
                    size: "mini",
                    onClick: handleRepairNotify
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('safeProtectionModule.repairNow')), 1)
                    ]),
                    _: 1
                  }, 8, ["disabled"]),
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createTextVNode(_toDisplayString(_ctx.$t('safeProtectionModule.repairSelectIntro')) + " ", 1),
                      _createVNode(_component_el_button, {
                        type: "text",
                        disabled: !repairData.total,
                        size: "mini",
                        onClick: openRepairItemDrawer
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(repairData.total), 1)
                        ]),
                        _: 1
                      }, 8, ["disabled"]),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('safeProtectionModule.repairSelectAuto')) + " ", 1),
                      _createVNode(_component_el_button, {
                        type: "text",
                        disabled: !repairData.alen,
                        size: "mini",
                        onClick: openRepairItemDrawer
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(repairData.alen), 1)
                        ]),
                        _: 1
                      }, 8, ["disabled"]),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('safeProtectionModule.repairSelectNotify')) + " ", 1),
                      _createVNode(_component_el_button, {
                        type: "text",
                        disabled: !repairData.nlen,
                        size: "mini",
                        onClick: openRepairItemDrawer
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(repairData.nlen), 1)
                        ]),
                        _: 1
                      }, 8, ["disabled"]),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('safeProtectionModule.repairSelectItemsSuffix')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_7, [
                      _createVNode(_component_el_button, {
                        type: "text",
                        disabled: !viewData.value.state.selectCount,
                        size: "mini",
                        onClick: openRepairItemDrawer
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('safeProtectionModule.selectRepairItems')) + " ", 1),
                          (viewData.value.state.selectCount)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_8))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["disabled"])
                    ])
                  ])
                ]),
                _createVNode(CmTableSelectionTipBar, { "bar-height": 34 }, {
                  summary: _withCtx(() => [
                    _createVNode(_component_i18n_t, {
                      keypath: "portManage.tipSelectedTerminalsTotal",
                      tag: "span",
                      class: "port-list-tip-bar__summary"
                    }, {
                      count: _withCtx(() => [
                        _createElementVNode("span", _hoisted_9, _toDisplayString(tipBarSelectedCount()), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  actions: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "text",
                      class: "cm-btn-text",
                      disabled: !viewData.value.tableData.length || viewData.value.state.selectAll,
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (handleTipSelect('all')))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('portManage.pageSelectAll')), 1)
                      ]),
                      _: 1
                    }, 8, ["disabled"]),
                    _createVNode(_component_el_button, {
                      type: "text",
                      class: "cm-btn-text",
                      disabled: !viewData.value.tableData.length || viewData.value.state.selectAll,
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (handleTipSelect('reverse')))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('sensitiveFileScanning.reversePage')), 1)
                      ]),
                      _: 1
                    }, 8, ["disabled"]),
                    _createVNode(_component_el_button, {
                      type: "text",
                      class: "cm-btn-text",
                      disabled: calcSelectAllScopeDisabled(),
                      onClick: selectAll
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('portManage.selectAllTerminals')), 1)
                      ]),
                      _: 1
                    }, 8, ["disabled"]),
                    _createVNode(_component_el_button, {
                      type: "text",
                      class: "cm-btn-text",
                      disabled: !viewData.value.tableData.some((item) => item.$selected) && !viewData.value.state.selectAll,
                      onClick: selectCancel
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('sensitiveFileScanning.cancelSelect')), 1)
                      ]),
                      _: 1
                    }, 8, ["disabled"])
                  ]),
                  _: 1
                })
              ])
            ]),
            "__sel-header": _withCtx(({ data }) => [
              _createVNode(_component_el_checkbox, {
                "model-value": pageSelectAllChecked(data),
                disabled: !data.length || viewData.value.state.selectAll || pageHeaderAllDisabled(data),
                indeterminate: pageSelectAllIndeterminate(data),
                onChange: (v) => handlePageSelectAllHeader(data, !!v)
              }, null, 8, ["model-value", "disabled", "indeterminate", "onChange"])
            ]),
            __sel: _withCtx(({ row }) => [
              _createVNode(UnauthorizedTooltip, {
                "permission-key": ModulePermissionKey[row.area_type],
                "device-id": row.device_id,
                "auth-status": _unref(getAuthByList)(row.auth_status, ModulePermissionKey[row.area_type]),
                "area-type": row.area_type,
                onAuthSuccess: handleAuthSuccess
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_checkbox, {
                    "model-value": row.$selected,
                    disabled: viewData.value.state.selectAll || isDisabled(row),
                    onChange: () => handleCheckbox(row)
                  }, null, 8, ["model-value", "disabled", "onChange"])
                ]),
                _: 2
              }, 1032, ["permission-key", "device-id", "auth-status", "area-type"])
            ]),
            _: 1
          }, 8, ["modelValue", "table-opt"])
        ])
      ]),
      _createVNode(_component_el_drawer, {
        modelValue: repairItemDrawer.value,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((repairItemDrawer).value = $event)),
        size: "70%",
        direction: "rtl",
        title: _ctx.$t('safeProtectionModule.selectRepairItems'),
        "before-close": handleRepairDrawerClose
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_tabs, {
            modelValue: activeName.value,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((activeName).value = $event)),
            style: {"padding":"0 0 0 15px"}
          }, {
            default: _withCtx(() => [
              (repairData.hasWindows)
                ? (_openBlock(), _createBlock(_component_el_tab_pane, {
                    key: 0,
                    label: _ctx.$t('safeProtectionModule.winTerminals'),
                    name: "baseline-win-terminals"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(WindowsRepairWrapper, {
                        "sub-ids": repairData.subIds
                      }, null, 8, ["sub-ids"])
                    ]),
                    _: 1
                  }, 8, ["label"]))
                : _createCommentVNode("", true),
              (repairData.hasLinux)
                ? (_openBlock(), _createBlock(_component_el_tab_pane, {
                    key: 1,
                    label: _ctx.$t('safeProtectionModule.linuxTerminals'),
                    name: "baseline-linux-terminals"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(LinuxRepairWrapper, {
                        "sub-ids": repairData.subIds
                      }, null, 8, ["sub-ids"])
                    ]),
                    _: 1
                  }, 8, ["label"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      }, 8, ["modelValue", "title"])
    ]),
    _: 1
  }))
}
}

})